import bootstrapNotify from '../../../../../../modules/Gull/Framework/bootstrapNotify.js';

const stap1 = {

	init() {

		// Set start
		var start = 1;

		// Voer checkOfVolgendeMag functie uit als pagina geladen is
		stap1.checkOfVolgendeMag();

		// Bind selects aan getdekking functie
		$('table.table-indienen select.Mij').change(stap1.getDekkingen);

		// Bind selects aan checkofvolgende mag functie functie
		$('table.table-indienen select.dekking').change(stap1.checkOfVolgendeMag);

		// Als er maar 1 aanbieder is zet dan de pulldown op die aanbieder
		$('.table-indienen tr select.Mij').each(function() {
			if ($(this).find('option').length == 2) {
				$(this).find('option:eq(1)').attr('selected', 'selected');
			}
		});

		// Trigger change op elke select zodat de waarde goed staat als de pagina geladen wordt
		$('table.table-indienen select').each(function() {
			$(this).trigger('change');
		});

		// Zet start op 0 als de pagina geladen is
		setTimeout(
			function() {
				start = 0;
			}, 1000
		);

	},

	// Functie om de bijbehorende dekkingen bij de maatschapij in de select te tonen
	getDekkingen4Mij: function(product, Mij) {
		var actionArray = [document.URL, 'getDekkingen4Mij', product, Mij, ''];

		$.getJSON(actionArray.join('/'), function(data) {
			if (data == false) {
				bootstrapNotify('danger', '', 'Er is iets fout gegaan met het opslaan van de gegevens!');
			} else {
				var options = [];
				options.push(
					'<option value=""> - </option>'
				);
				if (data != 'geen') {
					$.each(data, function(key, item) {
						if (item.correct.status == 1) {
							var text = '';
							if (item.textConsumer) {
								text = item.textConsumer;
							} else {
								text = item.text;
							}
							if (
								// Dienstverlening
								product == 'P610' ||
								product == 'P611' ||
								product == 'P612' ||
								product == 'P614' ||
								product == 'P642' ||
								product == 'P643' ||
								product == 'P644' ||
								product == 'P645' ||
								product == 'P646' ||
								product == 'P800' ||
								product == 'P613' ||
								product == 'P833' ||
								product == 'P841' ||
								product == 'P842' ||
								product == 'P843' ||
								product == 'P844') {
								text = text + ' &euro;' + (item.correct.factor * 1).toFixed(2) + ' per medewerker - &euro;' + item.correct.premie.toFixed(2) + ' totaal';
							} else if (
								// Consultancy
								product == 'P834' ||
								product == 'P836' ||
								product == 'P837' ||
								product == 'P838' ||
								product == 'P839' ||
								product == 'P840') {
								text = 'Aanvraag indienen';
							} else {
								text = text + ' ' + (item.correct.factor * 100).toFixed(3) + '% &euro;' + item.correct.premie.toFixed(2);
							}
							options.push(
								'<option value="', key, '" >', text, '</option>'
							);
						}
					});
				}
				$('select#Dekking_' + product).html(options.join(''));
				$('select#Dekking_' + product).val($('select#Dekking_' + product).attr('data-value'));
				$('select#Dekking_' + product).attr('data-value', '');
				$('select#Dekking_' + product).attr('name', 'prodMij[' + product + '][' + Mij + ']');
			}
			stap1.checkOfVolgendeMag();
		});
	},

	// Functie om de getDekkingen4Mij functie te draaien op de huidige select
	getDekkingen: function() {
		var selectedMij = $(this);
		stap1.getDekkingen4Mij(selectedMij.attr('id').split('_').pop(), selectedMij.val());
	},

	// Functie om de controleren of de producten / maatschappijen gecombineerd mogen worden
	checkOfVolgendeMag: function() {
		var errorText = '<br/><br/>Indien u &eacute;&eacute;n van de vereiste dekkingen reeds bij dezelfde Maatschappij in volmacht heeft afgesloten en dus niet opnieuw afsluit, kunt u de Maatschappij selecteren, maar de variant leeglaten.';

		var errorMsg = {};
		errorMsg['12jaarPropositie'] = 'De producten Ziektewet ERD en/of WGA ERD kunnen alleen in combinatie met een Ziekteverzuimverzekering bij dezelfde maatschappij worden aangevraagd.';
		errorMsg['PlusPakket'] = 'De door u gekozen dekkingssamenstelling is helaas niet mogelijk. Neem voor meer informatie contact op.';
		errorMsg['WIAExcedent'] = 'WGA en IVA excedent kunnen niet los en niet bij separate Maatschappijen worden aangevraagd.';

		$('[data-button-submit]').attr('disabled', true);

		var mag = 0;
		var magFamily = 1;
		var magVerplichtMet = 1;
		var familyObject = {};
		var familyObjectShow = {};

		$('table.table-indienen select.dekking').each(function() {
			if ($(this).val() != '') {
				var Mij = $(this).attr('name').split('][').slice(-1).pop().slice(0, -1);
				// var Prod = $(this).attr('name').split('[').slice(-2).shift().slice(0, -1);

				var curFamily = $(this).attr('data-family');
				if (curFamily != '') {
					$('select.dekking[family=' + curFamily + ']').closest('tr').removeClass('has-error');
					if (familyObject.hasOwnProperty(curFamily)) {
						if (familyObject[curFamily] != Mij) {
							if (errorMsg.hasOwnProperty(curFamily)) {
								if (stap1.start != 1) {
									if (!familyObjectShow.hasOwnProperty(curFamily)) {
										bootstrapNotify('danger', 'Let op!', errorMsg[curFamily] + errorText);
										familyObjectShow[curFamily] = 1;
									}
								}
								magFamily = 0;
							}
							$('select.dekking[data-value][family=' + curFamily + ']').closest('tr').addClass('has-error');
						}
					} else {
						familyObject[curFamily] = Mij;
					}
				}

				var curVerplichtMet = $(this).attr('data-verplichtMet');
				if (curVerplichtMet != '') {
					var verplichtArray = curVerplichtMet.split('|');
					for (var i = 0; i < verplichtArray.length; i++) {
						var value = $('select#Dekking_' + verplichtArray[i]).val();
						if (value == '') {
							magVerplichtMet = 0;
							bootstrapNotify('danger', 'Let op!', 'Dit product kan alleen afgesloten worden met ' + $('td#ProdName_' + verplichtArray[i]).html());
						}
					}
				}

				mag = 1;
			} else {
				$(this).closest('tr').removeClass('has-error');
			}
		});

		if (mag == 1 && magFamily == 1 && magVerplichtMet == 1) {
			$('[data-button-submit]').attr('disabled', false);
		}
	},

};

export default stap1;
